export const courses = [
  {
    id: "rock",
    title: "Rock",
    image: "https://images.unsplash.com/photo-1559189583-cd3b9a5f69c6?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Le rock à six temps : énergie, complicité et ce petit déclic qui donne envie de retourner sur la piste.",
    level: "Débutant à avancé",
    objective: "Maîtriser les bases, le guidage et quelques passes stylées.",
  },
  {
    id: "valse",
    title: "Valse",
    image: "https://images.unsplash.com/photo-1767784097441-217557272ef5?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Une valse fluide, élégante, qui glisse sans effort. Idéale pour les soirées et les mariages.",
    level: "Débutant à avancé",
    objective: "Posture, tour, contre-tour et musicalité.",
  },
  {
    id: "rock-acro",
    title: "Rock acrobatique",
    image: "https://images.unsplash.com/photo-1545959570-a94084071b5d?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Pour celles et ceux qui veulent ajouter du rythme, des figures et une vraie dynamique de couple.",
    level: "Intermédiaire à avancé",
    objective: "Énergie, synchronisation, premières acrobaties simples.",
  },
  {
    id: "salon",
    title: "Danse de salon",
    image: "https://images.unsplash.com/photo-1504609813442-a8924e83f76e?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Un répertoire varié pour devenir polyvalent en soirée.",
    level: "Tous niveaux",
    objective: "Acquérir un large vocabulaire et un style propre.",
  },
  {
    id: "mariage",
    title: "Danse de mariage",
    image: "https://images.unsplash.com/photo-1633978555421-1e67d524b227?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Une ouverture de bal préparée avec soin, adaptée à votre niveau, votre musique et votre ambiance.",
    level: "Sur-mesure",
    objective: "Une chorégraphie élégante, naturelle, mémorable.",
  },
  {
    id: "line",
    title: "Line dance",
    image: "https://images.unsplash.com/photo-1547153760-18fc86324498?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Des chorégraphies en ligne, conviviales, parfaites pour les groupes et les soirées thématiques.",
    level: "Tous niveaux",
    objective: "Apprendre rapidement plusieurs chorégraphies populaires.",
  },
];
